import React from 'react'
import { Layout } from '../components'

export default () => (
  <Layout>Het lijkt er op dat deze link niet meer werkt.</Layout>
)
